const license = {
    not_installed: '此執行個體尚未安裝授權。',
    invalid_key: '授權金鑰無效或已被竄改。',
    expired_key: '授權金鑰已過期。請取得新的金鑰並重新安裝。',
};
export default Object.freeze(license);
